import React,{PureComponent} from 'react';

import Login from 'components/Login';
import AuthApp from 'components/AuthApp';
import './authorise-view.css';

export default class AuthoriseView extends PureComponent{
    render(){
        return(
            <div className="authorise-view">
                <div className="authorise-intro">
                    {this.props.error ? <div>{this.props.error}</div> : null}
                    {this.props.success && !this.props.authenticated ? <Login/> : null}
                    {this.props.authenticated && !this.props.error && this.props.authApp ? 
                        <AuthApp
                            userName={this.props.user.fullName}
                            authApp={this.props.authApp}
                            query={this.props.query}/>
                    : null}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Authorise/AuthoriseView.js